import { CHECK_LEADS_UPLOADED_OR_NOT } from "../constant/ActionType";

export default function LeadsCheckReducerUPNot(
    state = {
        leadscheckornot: [],
        statusCode: null,
    },
    action
) {
    switch (action.type) {
        case CHECK_LEADS_UPLOADED_OR_NOT:
            return {
                ...state,
                leadscheckornot: action.data,
                statusCode: action.status,
            };

        default:
    }

    return state;
}
